export default '/src/assets/webgl/francesca/audios/global_intro.mp3'